import { Badge, List, ListSubheader, ListItemText, ListItemSecondaryAction, ListItemButton } from '@mui/material';
import axios from 'axios';
import { KeyValuePair } from 'helpers';
import { appUserContext } from "helpers/services";
import { TicketQueues } from 'helpers/Enums';
import ItemListResponse from 'helpers/interfaces/ItemListResponse';
import { LocalizationIds } from 'helpers/Localizations';
import { useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { ticketsContext } from '../TicketsContext';


export interface ITicketQueue {
    name: TicketQueues,
    label: string
}

let Queues = () => {
    let { formatMessage } = useIntl();

    let { currentUser } = useContext(appUserContext);
    let { ticketQueues, defaultSearch, search, doSearch } = useContext(ticketsContext);

    let [isLoading, setLoading] = useState(true);
    let [ticketQueuesCount, setTicketQueuesCount] = useState<KeyValuePair<TicketQueues, number>[]>([])

    useEffect(() => {
        getTicketQueuesCount();
    }, [])


    let getTicketQueuesCount = async () => {
        try {
            let res = await axios.get<ItemListResponse<KeyValuePair<TicketQueues, number>>>('/api/Ticket/GetTicketQueuesCount');
            setTicketQueuesCount(res.data.items);
            setLoading(false);
        } catch (err) { }
    }


    return (
        <List
            style={{ position: 'sticky', top: 0 }}
            component="nav"
            aria-labelledby="nested-list-subheader"
            subheader={<ListSubheader component="div" id="nested-list-subheader">{formatMessage({ id: LocalizationIds.Queue })}</ListSubheader>}
        >
            {ticketQueues
                .filter(queue => currentUser.simecClaims.canViewDashboard ? queue.name === queue.name : queue.name !== TicketQueues.Dashboard)
                .map(ticketQueue =>
                    <ListItemButton
                        color="secondary"
                        key={ticketQueue.name}
                        selected={search.ticketQueue === ticketQueue.name}
                        onClick={() => doSearch({ ...defaultSearch, ticketQueue: ticketQueue.name })}
                    >
                        <ListItemText primary={ticketQueue.label} />
                        {isLoading === false && ticketQueue.name !== TicketQueues.Dashboard && ticketQueue.name !== TicketQueues.AdvancedSearch &&
                            <ListItemSecondaryAction>
                                <Badge
                                    max={99999}
                                    color="secondary"
                                    badgeContent={ticketQueuesCount.getValueByKey(ticketQueue.name)?.toString() || '0'}
                                />
                            </ListItemSecondaryAction>
                        }
                    </ListItemButton>
                )}
        </List>
    )
}

export default Queues;